export const colors = {
  primary: '#799283' as const,
  white: '#ffffff',
  whiteThree: '#EBF1EF',
  whiteTwo: '#BEBEBE',
  black: '#212121',
  blackFour: '#363636',
  grey: '#5D5449',
  greyFour: '#6E6E6E',
  red: '#E23428',
  yellow: '#FB9F44',
  greyTwo: '#787878',
  greyThree: '#6D6D6D',
};
